import { render, staticRenderFns } from "./NamePosition.vue?vue&type=template&id=675ad56c&scoped=true&"
import script from "./NamePosition.vue?vue&type=script&lang=js&"
export * from "./NamePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ad56c",
  null
  
)

export default component.exports